// @ts-check
import React, { Component, useEffect } from "react";
import {
  Icon,
  Button,
  Row,
  Col,
  Divider,
  Tooltip,
  Modal,
  Table,
  notification,
  Input
} from "antd";
import SelectReusableStep from "../ReusableSteps/SelectReusableStep";
import { HotKeys } from "react-hotkeys";
import TCRichTextEditorv2 from "../common/TCRichTextEditorv2";
import DraggableComponents from "../common/DraggableComponents";
import withDNDContext from "../AdminSettings/withDNDContext";
import { ReusableStepsApi } from "../../services/generated-sdk";
import { handleError, sanitize } from "../../utils/common";
import InsertReusableStep from "../ReusableSteps/InsertReusableStep";
import { hasPermission } from "../Roles/common";
import { AppContext } from "../../AppContext";

const lodash = require("lodash");
import { _ } from "ag-grid-community";

function TestCaseStepInput({
  addStep,
  updateStep,
  updateExpectedResult,
  updateMentions,
  step,
  i,
  moveStep,
  cloneStep,
  deleteStep,
  showReusableStepLink,
  showReusableStepModal,
  showLabel,
  projectId,
  reusableSteps,
  canDelete = true,
  projectUsers = [],
  testParameters = []
}) {
  // if (step.reusableStepId) {
  //   return (
  //     <div>
  //       <ReusableStepPreview step={step} />
  //     </div>
  //   );
  // }

  const { company } = React.useContext(AppContext);
  const isNormalStep = step.reusableStepId ? false : true;
  const stepNumber = i + 1;
  let _reusableStepObj = {};
  if (!isNormalStep)
    _reusableStepObj = lodash.find(reusableSteps, { id: step.reusableStepId });

  const setFocusOn = btnId => {
    try {
      let titleElement = document.getElementById(`dummy-input-id-${i}`);
      if (titleElement) {
        titleElement.focus();
      }

      let btnElement = document.getElementById(btnId);
      if (btnElement) {
        btnElement.focus();
      }
    } catch (e) {}
  };

  return (
    <div key={`step_key_${i}`}>
      {showLabel == true && i == 0 ? (
        <Row style={{ marginTop: 15 }}>
          <Col span={12}>
            <strong>Steps:</strong>
          </Col>{" "}
          <Col span={12}>
            <strong>Expected Results:</strong>
          </Col>{" "}
        </Row>
      ) : null}

      <div>
        <Row style={{ marginTop: 15 }}>
          <Col span={1} style={{ fontWeight: "bold", marginTop: 12 }}>
            #{stepNumber}
          </Col>
          <Col span={10}>
            {isNormalStep ? (
              <TCRichTextEditorv2
                placeholder="step... (eg: Click on login button)"
                value={step.step}
                rows={2}
                setMentions={updateMentions}
                projectUsers={projectUsers}
                //autosize={{ minRows: 2, maxRows: 6 }}
                //style={{ marginRight: 2 }}
                onChange={updateStep}
                //key={`step_${i}`}
                company={company}
                // updateOnBlur={true}
                testParameters={testParameters}
              />
            ) : (
              <span>
                {_reusableStepObj && _reusableStepObj.steps
                  ? _reusableStepObj.steps.map((_step, stepCtr) => (
                      <li>
                        <b>
                          {stepNumber}.{stepCtr + 1}:
                        </b>{" "}
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html: sanitize(_step.step)
                          }}
                        />
                      </li>
                    ))
                  : null}{" "}
              </span>
            )}
          </Col>
          <Col span={1} style={{ textAlign: "center" }}>
            <br />
            <Icon type="arrow-right" />
            <div style={{ height: "1px", width: "1px", overflow: "hidden" }}>
              <Input id={`dummy-input-id-${i}`} />
            </div>
          </Col>
          <Col span={10}>
            {isNormalStep ? (
              <TCRichTextEditorv2
                rows={2}
                placeholder="expected result... (eg: Login form should appear in popup)"
                value={step.expectedResult}
                projectUsers={projectUsers}
                setMentions={updateMentions}
                //autosize={{ minRows: 2, maxRows: 6 }}
                onChange={updateExpectedResult}
                //key={`expected_${i}`}
                company={company}
                // updateOnBlur={true}
                testParameters={testParameters}
              />
            ) : (
              <span>
                {_reusableStepObj && _reusableStepObj.steps
                  ? _reusableStepObj.steps.map((_step, stepCtr) => (
                      <li>
                        <b>
                          {stepNumber}.{stepCtr + 1}:
                        </b>{" "}
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html: sanitize(_step.expectedResult)
                          }}
                        />
                      </li>
                    ))
                  : null}
              </span>
            )}
          </Col>
          <Col span={1} style={{ paddingLeft: 15 }}>
            <Tooltip title="Duplicate">
              <Button
                shape="circle"
                icon="copy"
                size="small"
                onClick={() => cloneStep(i)}
                data-tabindex="-1"
                id={`stp-clone-btn-${i}`}
                onMouseOver={e => setFocusOn(`stp-clone-btn-${i}`)}
              />
            </Tooltip>
            <br />
            <Tooltip title="Drag">
              <Button
                shape="circle"
                icon="drag"
                size="small"
                //onDrag={moveStep}
                //draggable
                data-tabindex="-1"
              />
            </Tooltip>
            <br />

            <Tooltip title="Delete">
              <Button
                disabled={!canDelete}
                shape="circle"
                icon="delete"
                size="small"
                type="danger"
                onClick={() => deleteStep(i)}
                data-tabindex="-1"
              />
            </Tooltip>
          </Col>
        </Row>

        <Row>
          <Col
            span={21}
            offset={1}
            style={{ textAlign: "center", marginTop: "10px" }}
          >
            <Divider>
              <Tooltip title="Insert a new step here">
                <Button
                  type="dashed"
                  shape="circle"
                  icon="plus"
                  onClick={addStep}
                  data-tabindex="-1"
                />
              </Tooltip>
              &nbsp;
              {showReusableStepLink === false ? null : (
                <span>
                  {/*
              <Tooltip title="Insert reusable step here">
                <Link
                  to={{
                    pathname: `/reusable_steps/select`,
                    // this is the trick!
                    state: { modal: true }
                  }}
                >
                  <Button
                    type="dashed"
                    shape="circle"
                    icon="thunderbolt"
                  //href="/reusable_steps/select"
                  //onClick={addStep}
                  />
                </Link>
              </Tooltip>
              */}
                  <Tooltip title="Insert reusable step here">
                    <Button
                      type="dashed"
                      shape="circle"
                      icon="thunderbolt"
                      onClick={() => showReusableStepModal(i)}
                      data-tabindex="-1"
                      id={`rs-stp-add-btn-${i}`}
                      onMouseOver={e => setFocusOn(`rs-stp-add-btn-${i}`)}
                    />
                  </Tooltip>
                </span>
              )}
            </Divider>
          </Col>
        </Row>
      </div>
    </div>
  );
}

function StepsIndex({
  steps,
  addStep,
  updateStep,
  moveStep,
  cloneStep,
  deleteStep,
  showReusableStepLink,
  showReusableStepModal,
  showLabel,
  TestCaseStepInputWithHotKey,
  reusableSteps,
  projectUsers = [],
  setStepMentions,
  testParameters = []
  //canAddReusableSteps
}) {
  const columns = [
    {
      title: "",
      dataIndex: "step",
      key: "step",
      render: (stepData, record, index) => {
        return (
          <TestCaseStepInputWithHotKey
            i={index}
            key={index}
            addStep={() => addStep(index)}
            updateStep={value => {
              updateStep("step", value, index);
            }}
            updateExpectedResult={value =>
              updateStep("expectedResult", value, index)
            }
            updateMentions={mentions => setStepMentions(mentions, index)}
            step={record}
            moveStep={(dragIndex, hoverIndex) =>
              console.log("move ............", dragIndex, hoverIndex)
            }
            cloneStep={cloneStep}
            deleteStep={deleteStep}
            showReusableStepLink={showReusableStepLink}
            showReusableStepModal={showReusableStepModal}
            reusableSteps={reusableSteps}
            showLabel={showLabel}
            canDelete={steps && steps.length > 1}
            projectUsers={projectUsers}
            testParameters={testParameters}
          />
        );
      }
    }
  ];

  const moveRow = (dragIndex, hoverIndex) => {
    moveStep(dragIndex, hoverIndex);
  };

  return (
    <div>
      <Table
        showHeader={false}
        columns={columns}
        dataSource={steps}
        pagination={false}
        //size="middle"
        //loading={loading}
        //onChange={onchange}
        bordered={false}
        components={DraggableComponents}
        onRow={(record, index) => ({
          index,
          moveRow: moveRow
        })}
        rowKey="key"
        className="add_steps"
      />
    </div>
  );
}
const StepsTable = withDNDContext(StepsIndex);

export class TestCaseStepInputCollection extends Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      positionToInsert: -1,
      allSteps: props.steps ? props.steps : [],
      reusableSteps: [],
      allReusableSteps: [],
      canAddReusableSteps:
        props.canAddReusableSteps != undefined
          ? props.canAddReusableSteps
          : true
    };
    this.TestCaseStepInputWithHotKey = this.withHotkeys(TestCaseStepInput);
  }

  componentDidMount() {
    window.addEventListener("reusableStepSelected", this.insertStep);
    window.addEventListener("resetSteps", this.resetSteps);

    this.fetchRUSteps();
  }

  componentDidUpdate(prevProps) {
    const diff = lodash.differenceBy(prevProps.value, this.props.value, "step");
    // console.log({ diff });
    if (diff && diff.length) {
      this.setSteps(undefined);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("reusableStepSelected", this.insertStep);
    window.removeEventListener("resetSteps", this.resetSteps);
  }

  resetSteps = () => {
    this.setState({ allSteps: [] });
  };
  setVisible = status => {
    this.setState({ visible: status });
  };

  setPositionToInsert = pos => {
    this.setState({ positionToInsert: pos });
  };

  resetPositionToInsert = () => {
    this.setState({ positionToInsert: -1 });
  };

  setSteps = steps => {
    this.setState({ allSteps: steps });
  };

  getStepKey = steps => {
    var newStepKey = 1;
    if (steps != undefined) {
      lodash.forEach(steps, function(item) {
        if (item.key) {
          if (item.key >= newStepKey) {
            newStepKey = item.key + 1;
          }
        }
      });
    }
    return newStepKey;
  };

  addKeys = items => {
    lodash.forEach(items, function(item, index) {
      item.key = index + 1;
    });
  };

  insertStep = e => {
    if (this.state.visible === true && this.state.positionToInsert >= 0) {
      const pos = this.state.positionToInsert;
      this.setVisible(false);
      this.resetPositionToInsert();

      const _reusableSteps = [...this.state.reusableSteps];
      _reusableSteps.push(e.detail);
      this.setState({ reusableSteps: _reusableSteps });
      // let newStep = [];
      // let newResult = [];
      // console.log(e.detail.steps);
      // lodash.map(e.detail.steps, (record, i) => {
      //   newStep.push(record.step);
      //   newResult.push(record.expectedResult);
      //   //newStep = newStep.concat(record.step);
      //   //newResult = newResult.concat(record.expectedResult);
      // });
      let blankStep = {
        //step: `[reusable_step:${e.detail.name}]`,
        key: this.getStepKey(this.state.allSteps),
        step: null,
        expectedResult: null,
        reusableStepId: e.detail.id
      };
      let steps = this.props.value || [];
      if (
        steps &&
        steps[pos] &&
        (steps[pos]["step"] || steps[pos]["expectedResult"])
      ) {
        steps.splice(pos + 1, 0, blankStep);
      } else {
        steps[pos] = blankStep;
      }
      this.onChange(steps);
      this.setSteps(steps);
    } else {
      //console.log("extra run....");
    }
  };

  fetchRUSteps = async () => {
    if (this.props.showReusableStepLink === false) {
      // console.log("do not fetch rusteps as adding rustep......");
      return;
    }
    const service = new ReusableStepsApi();
    try {
      const steps = await service.getAllReusableSteps({
        project: this.props.projectId,
        limit: -1
      });
      if (steps) {
        let reusableSteps = [];
        // if (this.props.value && this.props.value instanceof Array) {
        //   reusableSteps = this.props.value.map(
        //     v => if(v.reusableStepId){ reusableSteps.push()}
        //   );
        // }
        this.setState({ allReusableSteps: steps, reusableSteps: steps });
      }
    } catch (e) {
      // console.error("Reusable step(s) could not be fetched");
      // handleError(e.status);
      console.log({ fetchRUSteps_error: e });
      if (e.json) {
        e.json().then(data => {
          console.log({ fetchRUSteps_error2: data });
          handleError(data.statusCode, {}, data.message || "");
        });
      } else {
        notification.warn({
          message:
            e && e.message ? e.message : "Reusable step(s) could not be fetched"
        });
      }
    }
  };

  addStep = index => {
    let steps = this.props.value || [];
    if (steps != undefined) {
      this.addKeys(steps);
    }
    const blankStep = {
      key: this.getStepKey(steps),
      step: null,
      expectedResult: null,
      reusableStepId: null
    };
    if (steps) {
      steps.splice(index + 1, 0, blankStep);
    } else {
      steps = this.state.allSteps;
      steps.push(blankStep);
    }
    this.onChange(steps);
    this.setSteps(steps);
  };

  withHotkeys = Component => {
    return props => {
      const map = {
        addStep: ["ctrl+i"]
      };
      const keyHandlers = {
        addStep: () => this.addStep(props.i)
      };
      return (
        <HotKeys keyMap={map} handlers={keyHandlers}>
          <Component {...props} />
        </HotKeys>
      );
    };
  };

  debouncedOnChange = _.debounce(
    this.props.onChange,
    this.props.debounceChangeValue || 2000
  );

  onChange = steps => {
    // let newSteps = [...steps];
    // // todo: eliminate step / er from reusable steps
    // const actualSteps = newSteps.map(_step => {
    //   if (_step.reusableStepId) {
    //     _step.step = null;
    //     _step.expectedResult = null;
    //   }
    //   return _step;
    // });
    // console.log({ actualSteps });
    if (this.props.debounceChangeValue) {
      this.debouncedOnChange(steps);
    } else {
      this.props.onChange(steps);
    }
  };

  getSteps = (passed = undefined) => {
    let steps = [];
    const allSteps = passed ? [...passed] : this.state.allSteps;
    if (Array.isArray(allSteps)) {
      allSteps.map(step => {
        const isNormalStep = step.reusableStepId ? false : true;
        if (isNormalStep) {
          if (step && (step.step || step.expectedResult)) steps.push(step);
        } else {
          let _reusableStepObj = {};

          if (!isNormalStep)
            _reusableStepObj = lodash.find(this.state.reusableSteps, {
              id: step.reusableStepId
            });
          // console.log({ _reusableStepObj });
          if (_reusableStepObj && _reusableStepObj.steps) {
            steps = steps.concat(_reusableStepObj.steps);
          }
        }
      });
    }
    return steps;
  };
  setStepMentions = (newVal, index) => {
    return;
    let steps = this.state.allSteps;
    if (!steps) steps = [];
    if (!steps[index]) {
      steps[index] = { mentions: [] };
    }

    steps[index]["mentions"] = Array.isArray(steps[index]["mentions"])
      ? lodash.uniq(steps[index]["mentions"].concat(newVal))
      : newVal;

    // steps[index]["mentions"] = newVal;
    this.onChange(steps);
    this.setSteps(steps);
  };

  render() {
    let props = this.props;
    let steps = props.value;
    const canManageRU = hasPermission(
      this.context.loggedInUser,
      "manageRUSteps"
    );
    // console.log({ canManageRU });
    let _that = this;
    const blankStep = {
      key: 1,
      step: null,
      expectedResult: null,
      reusableStepId: null
    };

    if (steps != undefined) {
      _that.addKeys(steps);
    }

    if (steps == undefined && props.steps) {
      // console.log("populate props.steps...........");
      steps = props.steps;
      _that.addKeys(steps);
      _that.setSteps(steps);
    }

    if (steps == undefined || steps.length === 0) {
      steps = [blankStep];
      // _that.setSteps(steps);
    }

    const updateStep = (field, newVal, index) => {
      if (field === "mentions" && steps[index] instanceof Array) {
        steps[index]["mentions"] = new Set([
          ...steps[index]["mentions"],
          ...newVal
        ]);
      }
      if (steps && steps[index] != undefined) {
        steps[index][field] = newVal;
      } else {
        // console.log({ index_not_found: steps, index, field, newVal });
        steps[index] = {};
        steps[index][field] = newVal;
      }
      this.onChange(steps);
      _that.setSteps(steps);
    };
    const cloneStep = index => {
      //debugger;
      let tmp = { ...steps[index] };
      tmp.key = _that.getStepKey(steps);
      steps.splice(index + 1, 0, tmp);
      this.onChange(steps);
      _that.setSteps(steps);
    };
    const deleteStep = index => {
      if (steps && steps.length <= 1) {
        return notification.warn({
          message:
            "All steps can not be removed. At least 1 step should remain."
        });
      }
      steps.splice(index, 1);
      this.onChange(steps);
      _that.setSteps(steps);
    };

    const moveStep = (dragIndex, hoverIndex) => {
      let nSteps = [...steps];
      let tmp = nSteps[dragIndex];
      // console.log('SOPE', tmp);
      if (dragIndex > hoverIndex) {
        // Upward drag
        nSteps.splice(hoverIndex, 0, tmp);
        nSteps.splice(dragIndex + 1, 1);
      } else {
        // Downward drag
        nSteps.splice(dragIndex, 1);
        nSteps.splice(hoverIndex, 0, tmp);
      }
      this.onChange(nSteps);
      _that.setSteps(nSteps);
    };

    const showReusableStepModal = i => {
      this.setVisible(true);
      this.setPositionToInsert(i);
    };

    /*
    React.useEffect(() => {
      const insertStep = (e) => {
        console.log("customEvent triggered and listened......", e.detail);
        this.setVisible(false);
        this.setPositionToInsert(false);
      };

      window.addEventListener("reusableStepSelected", insertStep);
      return () => {
        window.removeEventListener("reusableStepSelected", insertStep);
      };
    }, []);
    */
    const TestCaseStepInputWithHotKey = this.TestCaseStepInputWithHotKey;
    const formatted = this.getSteps(
      this.state.allSteps == undefined || this.state.allSteps.length == 0
        ? steps
        : this.state.allSteps
    );

    return (
      <div key="step">
        {/* JSON.stringify(steps) 
        {steps.map((step, i) => {
          return (
            <TestCaseStepInputWithHotKey
              i={i}
              key={i}
              addStep={() => this.addStep(i)}
              updateStep={value => {
                //console.log(value);
                updateStep("step", value, i);
              }}
              updateExpectedResult={value =>
                updateStep("expectedResult", value, i)
              }
              step={step}
              moveStep={(dragIndex, hoverIndex) =>
                console.log("move ............", dragIndex, hoverIndex)
              }
              cloneStep={cloneStep}
              deleteStep={deleteStep}
              showReusableStepLink={
                props.showReusableStepLink != undefined
                  ? props.showReusableStepLink
                  : true
              }
              showReusableStepModal={showReusableStepModal}
              showLabel={props.showLabel != undefined ? props.showLabel : false}
            //components={this.components}
            />
          );
        })}
        */}
        <Modal
          visible={this.state.visible}
          onCancel={e => this.setVisible(false)}
          footer={[
            <Button
              type="primary"
              className="btn-success"
              icon="add"
              // disabled={!manageRUSteps}
              onClick={() => this.setState({ insertingRU: true })}
              disabled={
                !this.state.canAddReusableSteps
                  ? true
                  : Array.isArray(formatted) && formatted.length && canManageRU
                    ? false
                    : true
              }
            >
              Save current steps as reusable steps
            </Button>
            //<Button onClick={e => this.setVisible(false)}>Cancel</Button>
          ]}
          //onOk={e => this.setVisible(false)}
          // okButtonDisabled={true}
        >
          <SelectReusableStep
            reusableSteps={
              this.state.canAddReusableSteps ? this.state.allReusableSteps : []
            }
            canAddReusableSteps={this.state.canAddReusableSteps}
          />
        </Modal>
        <Modal
          visible={this.state.insertingRU}
          width="90%"
          onCancel={e => {
            this.setState({ insertingRU: false, visible: false }, () =>
              this.setVisible(true)
            );
          }}
          footer={null}
          destroyOnClose
          //onOk={e => this.setVisible(false)}
          // okButtonDisabled={true}
        >
          <InsertReusableStep
            steps={formatted}
            onSubmit={() => {
              this.setState({ insertingRU: false, visible: false });
              this.fetchRUSteps();
            }}
          />
        </Modal>
        <StepsTable
          steps={
            this.state.allSteps == undefined || this.state.allSteps.length == 0
              ? steps
              : this.state.allSteps
          }
          addStep={this.addStep}
          updateStep={updateStep}
          moveStep={moveStep}
          projectUsers={this.props.projectUsers}
          cloneStep={cloneStep}
          deleteStep={deleteStep}
          showReusableStepLink={
            props.showReusableStepLink != undefined
              ? props.showReusableStepLink
              : true
          }
          showReusableStepModal={showReusableStepModal}
          showLabel={props.showLabel != undefined ? props.showLabel : false}
          TestCaseStepInputWithHotKey={TestCaseStepInputWithHotKey}
          reusableSteps={this.state.reusableSteps}
          setStepMentions={this.setStepMentions}
          testParameters={this.props.testParameters}
          //canAddReusableSteps={this.state.canAddReusableSteps}
        />
      </div>
    );
  }
}
